// extracted by mini-css-extract-plugin
module.exports = {"giveMoreDetailswrapper":"style_giveMoreDetailswrapper__oiB13","rate":"style_rate__1vYmy","detailsWrapper":"style_detailsWrapper__1EQfo"};